import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Area from '../../../../../../common/chart/chartContainer/Area'
import { LegendItem } from '../../../../../../common/chart/legend/LegendItem'
import { Icon } from '../../../../../../common/html/icon'
import { Tooltip } from '../../../../../../common/tooltip'
import { getUnique } from '../../../../../../helpers/common'
import { formatVal, valToPercent } from '../../../../../../helpers/value'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'
import { getValueAndTitleCheckbox } from '../../../helper'
import { changeChecked, selectChecked } from '../../../store/slice'
import { selectIndicatorById } from '../store/slice'
import { TREND_LEFT_DATA } from './constant'

const findMax = (key, data) =>
  data.reduce((max, item) => {
    if (item[key] > max) {
      return item[key]
    }
    return max
  }, 0)

const ChartLeft = ({ id, data, check, isDynamicReport }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = TREND_LEFT_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const areas = checkboxs
    .filter((item) => checked.includes(item.value) && !item.disableFill)
    .sort((item1, item2) => {
      return findMax(item2.value, data) - findMax(item1.value, data)
    })

  const lines = checkboxs
    .filter((item) => checked.includes(item.value) && item.disableFill)
    .sort((item1, item2) => {
      return findMax(item2.value, data) - findMax(item1.value, data)
    })

  return (
    <div className="h100 flexColumn">
      <ChartContainer
        chartId={chartId.current}
        data={data}
        margin={{
          top: 10,
          bottom: 0,
          left: isDynamicReport ? 16 : 0,
          right: 16,
        }}
        width="100%"
        height="100%"
        xAxis={[
          {
            dataKey: 'year',
            type: 'category',
            tickFormatter: (year) => '‘' + String(year).slice(2, 4),
          },
        ]}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: [...areas, ...lines].map((item) => item.value),
            isBarChart: true,
            tickFormatter: (value) => formatVal(value, locale) + '%',
          },
        ]}
        tooltip={{
          schema: {
            content: [...areas, ...lines].map((item) => ({
              dataKey: item.value,
              label: item.title,
              formatValue: (value) => valToPercent(value, locale, true),
            })),
          },
        }}
      >
        {[...areas, ...lines].map((item) => {
          return (
            <Area
              key={item.value}
              yAxisId="left"
              dataKey={item.value}
              fill={item.color}
              stroke={item.color}
              strokeWidth={2}
              fillOpacity={item.disableFill ? 0 : 1}
              dot={{
                stroke: item.dotColor,
                fill: item.dotColor,
                fillOpacity: 1,
                strokeWidth: 1.5,
              }}
            />
          )
        })}
      </ChartContainer>
      <div className="flexColumn pt1">
        {checkboxs.map((item, index) => {
          return (
            <div
              style={{ marginTop: index ? 6 : undefined }}
              key={item.value}
              className="dFlex alignItemsCenter"
            >
              <LegendItem
                title={item.title}
                value={item.value}
                color={item.color}
                isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
                dataKey={item.value}
                chartId={chartId.current}
                listCheckBox={checked}
                setListCheckBox={setChecked}
                isDynamicReport={isDynamicReport}
              />
              {!isDynamicReport && (
                <Tooltip tooltipContent={item.tooltipContent}>
                  <Icon
                    className="icon-info-circle ml1"
                    style={{ color: '#9C9C9C', marginTop: 2 }}
                  />
                </Tooltip>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ChartLeft
